var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.71 0H68v79.8H.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.61 0C18.573 0 .71 17.863.71 39.902c0 21.399 16.845 38.86 37.997 39.852.633.031 1.266.047 1.902.047 10.215 0 19.532-3.84 26.59-10.153-4.676 3.102-10.144 4.887-15.988 4.887-9.5 0-18.012-4.715-23.734-12.148-4.41-5.207-7.27-12.907-7.465-21.547v-1.88c.195-8.64 3.054-16.339 7.465-21.546C33.199 9.984 41.71 5.27 51.21 5.27c5.844 0 11.316 1.785 15.992 4.886C60.18 3.875 50.918.04 40.762.004 40.71.004 40.66 0 40.609 0z",
    id: "c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.999%",
    y1: "0%",
    x2: "49.999%",
    y2: "100%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1B2D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1B2D",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1B2D",
    offset: "31.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1B2D",
    offset: "34.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE1B2D",
    offset: "37.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD1A2D",
    offset: "39.063%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD1A2C",
    offset: "40.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC1A2C",
    offset: "42.188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB1A2C",
    offset: "43.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA1A2C",
    offset: "44.531%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA192C",
    offset: "45.313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9192B",
    offset: "46.094%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9192B",
    offset: "46.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8192B",
    offset: "47.656%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8192B",
    offset: "48.438%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7192B",
    offset: "49.219%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6182B",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6182A",
    offset: "50.781%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5182A",
    offset: "51.563%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4182A",
    offset: "52.344%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4172A",
    offset: "53.125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3172A",
    offset: "53.906%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F21729",
    offset: "54.688%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F11729",
    offset: "55.469%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01729",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01629",
    offset: "57.031%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF1628",
    offset: "57.813%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1628",
    offset: "58.594%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1528",
    offset: "59.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC1528",
    offset: "60.156%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB1527",
    offset: "60.938%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1527",
    offset: "61.719%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E91427",
    offset: "62.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81427",
    offset: "62.891%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81426",
    offset: "63.281%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E71426",
    offset: "63.672%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E71426",
    offset: "64.063%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E61326",
    offset: "64.453%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E61326",
    offset: "64.844%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E51326",
    offset: "65.234%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E51326",
    offset: "65.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E41325",
    offset: "66.016%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E41325",
    offset: "66.406%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31225",
    offset: "66.797%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E21225",
    offset: "67.188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E21225",
    offset: "67.578%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E11225",
    offset: "67.969%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E11224",
    offset: "68.359%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E01224",
    offset: "68.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E01124",
    offset: "69.141%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1124",
    offset: "69.531%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE1124",
    offset: "69.922%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE1124",
    offset: "70.313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD1123",
    offset: "70.703%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD1023",
    offset: "71.094%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC1023",
    offset: "71.484%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB1023",
    offset: "71.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB1023",
    offset: "72.266%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA1023",
    offset: "72.656%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA1022",
    offset: "73.047%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D90F22",
    offset: "73.438%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D80F22",
    offset: "73.828%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D80F22",
    offset: "74.219%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D70F22",
    offset: "74.609%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60F21",
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60E21",
    offset: "75.391%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D50E21",
    offset: "75.781%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D40E21",
    offset: "76.172%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D40E21",
    offset: "76.563%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D30E21",
    offset: "76.953%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D20D20",
    offset: "77.344%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D20D20",
    offset: "77.734%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D10D20",
    offset: "78.125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D00D20",
    offset: "78.516%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D00C20",
    offset: "78.906%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF0C1F",
    offset: "79.297%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C1F",
    offset: "79.688%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C1F",
    offset: "80.078%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD0C1F",
    offset: "80.469%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC0B1F",
    offset: "80.859%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB0B1E",
    offset: "81.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB0B1E",
    offset: "81.641%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA0B1E",
    offset: "82.031%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C90A1E",
    offset: "82.422%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C80A1E",
    offset: "82.813%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C80A1D",
    offset: "83.203%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C70A1D",
    offset: "83.594%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60A1D",
    offset: "83.984%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5091D",
    offset: "84.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5091C",
    offset: "84.766%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4091C",
    offset: "85.156%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3091C",
    offset: "85.547%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2081C",
    offset: "85.938%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2081C",
    offset: "86.328%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1081B",
    offset: "86.719%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0081B",
    offset: "87.109%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF071B",
    offset: "87.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE071B",
    offset: "87.891%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE071A",
    offset: "88.281%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD071A",
    offset: "88.672%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC061A",
    offset: "89.063%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB061A",
    offset: "89.453%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA061A",
    offset: "89.844%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA0619",
    offset: "90.234%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B90519",
    offset: "90.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B80519",
    offset: "91.016%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B70519",
    offset: "91.406%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B60518",
    offset: "91.797%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B50418",
    offset: "92.188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B50418",
    offset: "92.578%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B40418",
    offset: "92.969%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B30417",
    offset: "93.359%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B20317",
    offset: "93.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B10317",
    offset: "94.141%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B00317",
    offset: "94.531%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF0316",
    offset: "94.922%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0216",
    offset: "95.313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0216",
    offset: "95.703%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD0216",
    offset: "96.094%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC0115",
    offset: "96.484%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0115",
    offset: "96.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA0115",
    offset: "97.266%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A90115",
    offset: "97.656%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80014",
    offset: "98.047%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A70014",
    offset: "98.438%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A70014",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M0 0h54v70H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.477 12.414c3.66-4.32 8.39-6.926 13.554-6.926 11.617 0 21.032 13.168 21.032 29.414 0 16.243-9.415 29.41-21.032 29.41-5.164 0-9.894-2.605-13.554-6.925C6.199 64.82 14.71 69.535 24.21 69.535c5.844 0 11.312-1.785 15.988-4.887 8.168-7.308 13.313-17.925 13.313-29.746 0-11.82-5.145-22.441-13.309-29.746C35.527 2.055 30.055.27 24.211.27 14.71.27 6.199 4.984.477 12.414",
    id: "h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.998%",
    y1: "-.001%",
    x2: "49.998%",
    y2: "99.997%",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000",
    offset: ".781%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D0000",
    offset: "1.172%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D0101",
    offset: "1.563%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E0101",
    offset: "1.953%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E0202",
    offset: "2.344%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F0202",
    offset: "2.734%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F0202",
    offset: "3.125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A00303",
    offset: "3.516%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A00303",
    offset: "3.906%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A10404",
    offset: "4.297%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A10404",
    offset: "4.688%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A20505",
    offset: "5.078%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A30505",
    offset: "5.469%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A30505",
    offset: "5.859%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A40606",
    offset: "6.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A40606",
    offset: "6.641%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A50707",
    offset: "7.031%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A50707",
    offset: "7.422%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A60808",
    offset: "7.813%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A70808",
    offset: "8.203%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A70808",
    offset: "8.594%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80909",
    offset: "8.984%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80909",
    offset: "9.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A90A0A",
    offset: "9.766%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A90A0A",
    offset: "10.156%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA0B0B",
    offset: "10.547%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA0B0B",
    offset: "10.938%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0B0B",
    offset: "11.328%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC0C0C",
    offset: "11.719%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC0C0C",
    offset: "12.109%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD0D0D",
    offset: "12.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD0D0D",
    offset: "12.891%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0D0D",
    offset: "13.281%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0E0E",
    offset: "13.672%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF0E0E",
    offset: "14.063%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF0F0F",
    offset: "14.453%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B00F0F",
    offset: "14.844%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11010",
    offset: "15.234%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11010",
    offset: "15.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B21010",
    offset: "16.016%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B21111",
    offset: "16.406%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31111",
    offset: "16.797%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31212",
    offset: "17.188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41212",
    offset: "17.578%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51313",
    offset: "17.969%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51313",
    offset: "18.359%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B61313",
    offset: "18.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B61414",
    offset: "19.141%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B71414",
    offset: "19.531%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B71515",
    offset: "19.922%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B81515",
    offset: "20.313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B81616",
    offset: "20.703%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B91616",
    offset: "21.094%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA1616",
    offset: "21.484%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA1717",
    offset: "21.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB1717",
    offset: "22.266%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB1818",
    offset: "22.656%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC1818",
    offset: "23.047%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC1919",
    offset: "23.438%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD1919",
    offset: "23.828%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD1919",
    offset: "24.219%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE1A1A",
    offset: "24.609%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF1A1A",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF1B1B",
    offset: "25.391%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C01B1B",
    offset: "25.781%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C01B1B",
    offset: "26.172%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C11C1C",
    offset: "26.563%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C11C1C",
    offset: "26.953%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C21D1D",
    offset: "27.344%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C21D1D",
    offset: "27.734%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C31E1E",
    offset: "28.125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41E1E",
    offset: "28.516%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41E1E",
    offset: "28.906%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C51F1F",
    offset: "29.297%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C51F1F",
    offset: "29.688%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C62020",
    offset: "30.078%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C62020",
    offset: "30.469%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72121",
    offset: "30.859%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C82121",
    offset: "31.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C82121",
    offset: "31.641%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C92222",
    offset: "32.031%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C92222",
    offset: "32.422%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA2323",
    offset: "32.813%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA2323",
    offset: "33.203%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB2424",
    offset: "33.594%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB2424",
    offset: "33.984%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2424",
    offset: "34.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD2525",
    offset: "34.766%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD2525",
    offset: "35.156%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE2626",
    offset: "35.547%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE2626",
    offset: "35.938%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF2626",
    offset: "36.328%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF2727",
    offset: "36.719%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D02727",
    offset: "37.109%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D02828",
    offset: "37.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D12828",
    offset: "37.891%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D22929",
    offset: "38.281%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D22929",
    offset: "38.672%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D32929",
    offset: "39.063%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D32A2A",
    offset: "39.453%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D42A2A",
    offset: "39.844%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D42B2B",
    offset: "40.234%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52B2B",
    offset: "40.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D62C2C",
    offset: "41.016%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D62C2C",
    offset: "41.406%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D72C2C",
    offset: "41.797%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D72D2D",
    offset: "42.188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D2D",
    offset: "42.578%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82E2E",
    offset: "42.969%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D92E2E",
    offset: "43.359%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D92F2F",
    offset: "43.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA2F2F",
    offset: "44.141%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB2F2F",
    offset: "44.531%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3030",
    offset: "44.922%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3030",
    offset: "45.313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3131",
    offset: "45.703%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD3131",
    offset: "46.094%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD3232",
    offset: "46.484%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE3232",
    offset: "46.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE3232",
    offset: "47.266%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF3333",
    offset: "47.656%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03333",
    offset: "48.047%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03434",
    offset: "48.438%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E13434",
    offset: "48.828%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E13434",
    offset: "49.219%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E23535",
    offset: "49.609%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E23535",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33636",
    offset: "50.391%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E43636",
    offset: "50.781%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E43737",
    offset: "51.172%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E53737",
    offset: "51.563%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E53737",
    offset: "51.953%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E63838",
    offset: "52.344%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E63838",
    offset: "52.734%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73939",
    offset: "53.125%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73939",
    offset: "53.516%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E83A3A",
    offset: "53.906%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E93A3A",
    offset: "54.297%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E93A3A",
    offset: "54.688%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA3B3B",
    offset: "55.078%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA3B3B",
    offset: "55.469%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3C3C",
    offset: "55.859%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3C3C",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC3D3D",
    offset: "56.641%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC3D3D",
    offset: "57.031%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3D3D",
    offset: "57.422%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE3E3E",
    offset: "57.813%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE3E3E",
    offset: "58.203%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3F3F",
    offset: "58.594%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3F3F",
    offset: "58.984%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F03F3F",
    offset: "59.375%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04040",
    offset: "59.766%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F14040",
    offset: "60.156%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F14141",
    offset: "60.547%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F24141",
    offset: "60.938%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34242",
    offset: "61.328%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34242",
    offset: "61.719%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44242",
    offset: "62.109%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44343",
    offset: "62.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F54343",
    offset: "62.891%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F54444",
    offset: "63.281%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F64444",
    offset: "63.672%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74545",
    offset: "64.063%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74545",
    offset: "64.453%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F84545",
    offset: "64.844%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F84646",
    offset: "65.234%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F94646",
    offset: "65.625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F94747",
    offset: "66.016%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4747",
    offset: "66.406%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4848",
    offset: "66.797%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB4848",
    offset: "67.188%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC4848",
    offset: "67.578%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC4949",
    offset: "67.969%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4949",
    offset: "68.359%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4A4A",
    offset: "68.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE4A4A",
    offset: "69.141%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE4B4B",
    offset: "69.531%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4B4B",
    offset: "70.313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4B4B",
    offset: "71.875%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4B4B",
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4B4B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "nonzero",
    mask: "url(#e)",
    d: "M67.203 0H.711v79.8h66.492z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillRule: "nonzero",
    mask: "url(#j)",
    d: "M53.512.27H.477v69.265h53.035z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpera);
export default __webpack_public_path__ + "static/media/opera.ec1b2fcb.svg";
export { ForwardRef as ReactComponent };